import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ScrollToTopButton } from './ScrollToTopButton';
import { TableHeadStyled } from './StickyTableHead.styled';
const StickyTableHead = forwardRef(({ withScrollToStartIcon, children, ...props }, ref) => {
    const { isCurrentlySticky } = props;
    return (_jsx(_Fragment, { children: _jsxs(TableHeadStyled, { ref: ref, ...props, children: [children, withScrollToStartIcon && isCurrentlySticky && _jsx(ScrollToTopButton, {})] }) }));
});
export { StickyTableHead };
